var map = {
	"./clinic-01.png": 48456,
	"./clinic-02.png": 13471,
	"./clinic-03.png": 68309,
	"./clinic-04.png": 83507,
	"./clinic-05.png": 19175,
	"./clinic-06.png": 2180,
	"./clinic-1.jpg": 17294,
	"./clinic-10.jpg": 39240,
	"./clinic-11.jpg": 64110,
	"./clinic-12.jpg": 57989,
	"./clinic-2.jpg": 77062,
	"./clinic-3.jpg": 71041,
	"./clinic-4.jpg": 43398,
	"./clinic-5.jpg": 10083,
	"./clinic-6.jpg": 98697,
	"./clinic-7.jpg": 83841,
	"./clinic-8.jpg": 21657,
	"./clinic-9.jpg": 99685,
	"./service-1.jpg": 87077,
	"./service-2.jpg": 39266,
	"./service-3.jpg": 19342,
	"./service-4.jpg": 61896,
	"./service-5.jpg": 51813,
	"./service-6.jpg": 86987,
	"./spec-01.jpg": 99726,
	"./spec-02.jpg": 79826,
	"./spec-03.jpg": 74176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5022;